export interface ApiResponse<T> {
  code: number
  msg: string
  data: T
  success: boolean
  traceId?: string
}

export interface PaginatedData<T> {
  list: T[]
  total: number
  hasNext: boolean
}

export type PaginatedResponse<T> = ApiResponse<PaginatedData<T>>

export function isSuccess<T>(response: ApiResponse<T>): boolean {
  return response.code === 200
}
